export default __webpack_public_path__ + "static/krasnoyarsk-2-mobile-0467b493191ca9e2b85badd70d32b3c6.jpg";